// Staff-only API calls (/api/config, /api/admin) carry the admin key. It is
// asked for once, on the first refused call, and remembered in this browser.
// public/admin-bikebuilder.html reads the same storage entry.
export const ADMIN_KEY_STORAGE = 'bikebuilder-admin-key';

const isAdminUrl = url => /^\/?api\/(config|admin)\//.test(url || '');

export function installAdminKey(axios, {
  storage = window.localStorage,
  ask = () => window.prompt('Admin key')
} = {}) {
  const read = () => { try { return storage.getItem(ADMIN_KEY_STORAGE) || ''; } catch (e) { return ''; } };
  const write = key => { try { storage.setItem(ADMIN_KEY_STORAGE, key); } catch (e) { /* private mode: ask again next time */ } };

  axios.interceptors.request.use(config => {
    const key = read();
    if (key && isAdminUrl(config.url)) config.headers = { ...config.headers, Authorization: `Bearer ${key}` };
    return config;
  });
  axios.interceptors.response.use(null, error => {
    const { config, response } = error;
    if (!config || !response || response.status !== 401 || !isAdminUrl(config.url) || config.adminKeyRetry) throw error;
    const key = (ask() || '').trim();
    if (!key) throw error;
    write(key);
    return axios({ ...config, adminKeyRetry: true, headers: { ...config.headers, Authorization: `Bearer ${key}` } });
  });
}
